import { Alert, Stack, Typography } from "@mui/material";
import { RejectionGroups } from "Components/Merchant/OrbitL/RejectionGroups";
import type { RejectionGroupDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  groups: Array<RejectionGroupDto>;
};

export const RejectionSection = ({ groups }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">
        {t(RESOURCES.RejectionSection)}
      </Typography>
      <Alert severity="warning">
        <RejectionGroups groups={groups} />
      </Alert>
    </Stack>
  );
};
